import {
  Directive,
  AfterContentChecked
} from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';

import { AppMenuLinkDirective } from './appmenulink.directive';

@Directive({
  selector: '[appMenu]'
})
export class AppMenuDirective implements AfterContentChecked {
  protected navlinks: Array<AppMenuLinkDirective> = [];

  closeOtherLinks(selectedLink: AppMenuLinkDirective): void {
    this.navlinks.forEach((link: AppMenuLinkDirective) => {
      if (link !== selectedLink) {
        link.selected = false;
        link.preselect = false;
      }
    });
  }

  unselectOthersLinks(selectedLink: AppMenuLinkDirective): void {
    this.navlinks.forEach((link: AppMenuLinkDirective) => {
      if (link !== selectedLink) {
        link.preselect = false;
      }
    });
  }

  addLink(link: AppMenuLinkDirective): void {
    this.navlinks.push(link);
  }

  removeGroup(link: AppMenuLinkDirective): void {
    const index = this.navlinks.indexOf(link);
    if (index !== -1) {
      this.navlinks.splice(index, 1);
    }
  }

  checkOpenLinks() {
    this.navlinks.forEach((link: AppMenuLinkDirective) => {
      if (link.group) {
        const routeUrl = this.router.url;
        const currentUrl = routeUrl.split('/');
        if (currentUrl.indexOf(link.group) > 0) {
          link.selected = true;
          this.closeOtherLinks(link);
        }
      }
    });
  }

  ngAfterContentChecked(): void { }

  constructor(private router: Router) {
    setTimeout(() => this.checkOpenLinks());
  }
}
